import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import StyledAvailabilityActionButton from 'common/theme/availability/StyledAvailabilityActionButton';
import ConfirmDeleteModal from 'components/shared/modals/ConfirmDeleteModal';
import availabilityApi from 'api/graphql/availability';
import availabilitySlice from 'store/modules/availability';
import uiSlice from 'store/modules/ui';
import { createSnack, getUserFriendlyError } from 'common/utils/general';

function AvailabilityDeleteAllButton() {
  const { t } = useTranslation(['buttons', 'notifications', 'availabilities']);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const userId = useSelector((state) => state.auth.user.id);
  const latest = useSelector((state) => state.availability.data.latest);

  const hasAvailabilities = latest !== null;

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    if (!isLoading) setOpen(false);
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await availabilityApi.deleteAll(parseInt(userId, 10));

      const snack = createSnack({
        key: 'availability-delete-all-success',
        variant: 'success',
        message: t('availability.deleteAll', { ns: 'notifications' })
      });

      dispatch(uiSlice.actions.enqueueSnackbar(snack));
      dispatch(availabilitySlice.actions.reset());
      setIsLoading(false);
      setOpen(false);
    } catch (error) {
      const message = getUserFriendlyError(error);
      const snack = createSnack({
        key: 'availability-delete-all-error',
        variant: 'error',
        message
      });

      dispatch(uiSlice.actions.enqueueSnackbar(snack));
      setIsLoading(false);
      setOpen(false);
    }
  };

  return (
    <>
      <StyledAvailabilityActionButton
        onClick={handleOpen}
        disabled={isLoading || !hasAvailabilities}>
        <span>{t('deleteAll', { ns: 'buttons' })}</span>
      </StyledAvailabilityActionButton>

      <ConfirmDeleteModal
        open={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title={t('deleteAllTitle', {
          ns: 'availabilities',
          defaultValue: '¿Eliminar toda la disponibilidad?'
        })}
        message={t('deleteAllMessage', {
          ns: 'availabilities',
          defaultValue:
            'Esto eliminará todas tus disponibilidades futuras que no tengan sesiones programadas. Las sesiones con clientes NO se verán afectadas.'
        })}
        note=""
        confirmLabel={t('delete', { ns: 'buttons' })}
        cancelLabel={t('cancel', { ns: 'buttons' })}
      />
    </>
  );
}

export default AvailabilityDeleteAllButton;
